module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "intro_page"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "title1"
  }, [_vm._v("INTRODUCTION / "), _c('i', [_vm._v("Michael J. Curley")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "intro_p1"
    }
  }, [_c('b', [_vm._v("P")]), _c('i', [_vm._v("hysiologus")]), _vm._v(" was one of the most popular and widely read books of the Middle Ages. Some of the legends concerning beasts, stones, and trees which are found allegorized in "), _c('i', [_vm._v("Physiologus")]), _vm._v(" were part of folklore as early as Herodotus, and they have continued to exercise a strong influence on literature and the decorative arts down to the present day."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn1",
      "id": "fnr1"
    }
  }, [_vm._v("1")])]), _vm._v(" The reason is not far to seek: we all love simple, well-told stories for their own sake. And, if a bit of exotic lore can be mingled with useful moral instruction, so much the better. We never stop to ask that animal stories be zoologically accurate, for that would be missing their point. The charm of these legends lies in their simplicity, one might even say in their naïveté, but their popularity was assured by their ready adaptability to a variety of cultural contexts, religious as well as secular. Beginning as Indian, Hebrew, or Egyptian legends, they passed into Greek and Roman folklore, poetry, and art, ultimately being absorbed into Alexandrian handbooks of paradoxology and medical-magical treatises."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn2",
      "id": "fnr2"
    }
  }, [_vm._v("2")])]), _vm._v(" From there, ancient scientific writers such as Pliny and Aelian passed down many of these legends to the early Christian world. The anonymous author of "), _c('i', [_vm._v("Physiologus")]), _vm._v(" infused these venerable pagan tales with the spirit of Christian moral and mystical teaching, and thereafter they occupied a place of special importance in the symbolism of the Christian world. Both directly and through numerous intermediaries, "), _c('i', [_vm._v("Physiologus")]), _vm._v(" became an established source of Medieval sacred iconography and didactic poetry and was used in the preaching manuals and religious textbooks of the later Middle Ages."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn3",
      "id": "fnr3"
    }
  }, [_vm._v("3")])]), _vm._v(" The forms which the book assumed were protean; sometimes the legends circulated independent of the allegories or the supporting Biblical citations. In one instance,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn4",
      "id": "fnr4"
    }
  }, [_vm._v("4")])]), _vm._v(" the allegories themselves were"), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v(" copied down without the legends. The forty-odd chapters which comprised the original Greek text grew to over a hundred in some of the Latin bestiaries which were inspired by "), _c('i', [_vm._v("Physiologus.")]), _vm._v(" Translations of the text appeared in virtually every European vernacular, including Old English and Icelandic, providing the widest possible audience for this model "), _c('i', [_vm._v("par excellence")]), _vm._v(" of the allegorical method of interpreting natural history.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p2"
    }
  }, [_vm._v("The following remarks are intended to introduce the reader to "), _c('i', [_vm._v("Physiologus")]), _vm._v(" and to place it within its intellectual and historical framework. For those who might wish to pursue the topic in greater detail, I have attached a selective bibliography.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "intro_p3"
    }
  }, [_vm._v("THE AUTHOR")]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "intro_p4"
    }
  }, [_c('b', [_vm._v("T")]), _vm._v("he Greek word "), _c('img', {
    attrs: {
      "alt": "",
      "height": "20",
      "src": "images/page_x_1.jpg",
      "width": "95"
    }
  }), _vm._v(" (from "), _c('img', {
    attrs: {
      "alt": "",
      "height": "23",
      "src": "images/page_x_2.jpg",
      "width": "65"
    }
  }), _vm._v(", nature, and "), _c('img', {
    attrs: {
      "alt": "",
      "height": "22",
      "src": "images/page_x_3.jpg",
      "width": "65"
    }
  }), _vm._v(", word or reason) has a special meaning distinct from our English cognate “physiology.” Aristotle, who was the first to use the term, speaks of certain pre-Socratic philosophers, Anaxagoras, Empedocles and Democritus in particular, as "), _c('img', {
    attrs: {
      "alt": "",
      "height": "20",
      "src": "images/page_x_4.jpg",
      "width": "93"
    }
  }), _vm._v(" (Gen. an. 4. 1. 763 31). Here and elsewhere "), _c('i', [_vm._v("(De anima")]), _vm._v(" 426a20), where he discusses the early theorists on the nature of sight, Aristotle uses the term to describe what we might call zoologists. But in his "), _c('i', [_vm._v("Metaphysics")]), _vm._v(" (986b14; 989b30; 990a3) the "), _c('img', {
    attrs: {
      "alt": "",
      "height": "20",
      "src": "images/page_x_4.jpg",
      "width": "93"
    }
  }), _vm._v(" are mentioned as speculative natural philosophers (again he has certain pre-Socratics in mind) who developed a theoretical system to account for the unity of the universe and the origin of being. In contrast to the Pythagoreans, who rely solely on mathematics in their philosophy, the "), _c('img', {
    attrs: {
      "alt": "",
      "height": "20",
      "src": "images/page_x_4.jpg",
      "width": "93"
    }
  }), _vm._v(" base their system on the observation of nature ("), _c('img', {
    attrs: {
      "alt": "",
      "height": "23",
      "src": "images/page_x_2.jpg",
      "width": "65"
    }
  }), _vm._v("), much as Aristotle himself did."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn5",
      "id": "fnr5"
    }
  }, [_vm._v("5")])]), _vm._v(" In the "), _c('i', [_vm._v("Parts of Animals")]), _vm._v(" (641a7), these philosophers are mentioned along with Democritus as being concerned with the formation and"), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v(" causes of the shapes of animal bodies. In general, therefore, the word "), _c('img', {
    attrs: {
      "alt": "",
      "height": "22",
      "src": "images/page_xi_1.jpg",
      "width": "96"
    }
  }), _vm._v(" as first used by Aristotle was applied to philosophers whose theories about natural phenomena were grounded in observation of the sensible world and, in particular, of animal life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p5"
    }
  }, [_vm._v("A rather different meaning is attached to the term in Diodorus Siculus and in Cicero. Describing the honors accorded the Tyrrhenians (i.e., the Etruscans), Diodorus notes that these people excelled in the perfecting of letters "), _c('img', {
    attrs: {
      "alt": "",
      "height": "21",
      "src": "images/page_xi_3.jpg",
      "width": "87"
    }
  }), _vm._v(", "), _c('img', {
    attrs: {
      "alt": "",
      "height": "20",
      "src": "images/page_x_1.jpg",
      "width": "95"
    }
  }), _vm._v(" and theology. He then proceeds to explain that they elaborated the craft of divination, being especially gifted in interpreting the omens of Zeus through thunder and lightning."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn6",
      "id": "fnr6"
    }
  }, [_vm._v("6")])]), _vm._v(" This association of the term with knowledge of the secret, occult operations of the natural world explains why it can be coupled with theology. I assume that to Diodorus "), _c('img', {
    attrs: {
      "alt": "",
      "height": "21",
      "src": "images/page_xi_3.jpg",
      "width": "87"
    }
  }), _vm._v(" would include incantations and religious-magical formulas, for in no other kind of “letters” were the Etruscans known to excel. Cicero, Diodorus’s Latin contemporary, shows that the meaning of "), _c('img', {
    attrs: {
      "alt": "",
      "height": "20",
      "src": "images/page_x_1.jpg",
      "width": "95"
    }
  }), _vm._v(" had acquired a new range of meaning since Aristotle’s day. In his "), _c('i', [_vm._v("De divinatione")]), _vm._v(" (1. 40. 90) Cicero’s brother Quintus, speaking about the practice of divination among the Gauls, mentions that he has firsthand knowledge of the topic, through personal acquaintance with a Druid named Divitiacus. “He claimed to have that knowledge of nature which the Greeks call ‘physiologia,’ and he used to make predictions, sometimes by means of augury and sometimes by means of conjecture.” By the beginning of the Christian era, in other words, in both the Latin and the Greek worlds, "), _c('img', {
    attrs: {
      "alt": "",
      "height": "20",
      "src": "images/page_x_1.jpg",
      "width": "95"
    }
  }), _vm._v(" had acquired a range of meaning extending from early Greek speculative zoology and physics to the occult religious practices of exotic peoples.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p6"
    }
  }, [_vm._v("Among the ancients, however, it is to Plutarch’s treatise "), _c('i', [_vm._v("On Isis and Osiris")]), _vm._v(" that we must turn to find the first"), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _vm._v(" explicit association of animal symbolism with theological speculation. Plutarch claims that the Egyptians based their sacred symbolism on natural phenomena, which supposedly contained esoteric teachings about the nature of the gods. He mentions, for example, that the crocodile is honored among the Egyptians as the living representation of God since he is the only creature without a tongue, “for the divine word has no need of a voice” "), _c('img', {
    attrs: {
      "alt": "",
      "height": "22",
      "src": "images/page_xii_1.jpg",
      "width": "337"
    }
  }), _vm._v(","), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn7",
      "id": "fnr7"
    }
  }, [_vm._v("7")])]), _vm._v(" and that he is endowed with a nictating membrane allowing him, like God, to see without being seen "), _c('img', {
    attrs: {
      "alt": "",
      "height": "20",
      "src": "images/page_xii_3.jpg",
      "width": "53"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "23",
      "src": "images/page_xii_4.jpg",
      "width": "433"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "23",
      "src": "images/page_xii_4.jpg",
      "width": "433"
    }
  }), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn8",
      "id": "fnr8"
    }
  }, [_vm._v("8")])]), _vm._v(" In a later passage, Plutarch compares the ‘Greek custom of representing divine qualities in statues and in numbers and figures (as among the Pythagoreans) with Egyptian animal symbolism:")]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "intro_p7"
    }
  }, [_vm._v("If, then, the most noted of the philosophers, observing the enigma of the divine "), _c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/page_xii_5.jpg",
      "width": "150"
    }
  }), _vm._v(" in inanimate and incorporeal objects, have not thought it proper to treat anything with carelessness or disrespect, even more do I think that, in all likelihood, we should welcome those peculiar properties existent in natures which possess the power of perception and have a soul and feeling and character. It is not that we should honor these but that through these we should honor the Divine, since they are the clearer mirrors of the Divine by their nature also, so that we should regard them as the instrument or the device of the God who orders all things…. The nature that lives and sees and has within itself the source of movement and a knowledge of what belongs to it and what belongs to others has drawn to itself an efflux and portion of beauty from the Intelligence “by which the Universe is guided” "), _c('img', {
    attrs: {
      "alt": "",
      "height": "17",
      "src": "images/page_xii_6.jpg",
      "width": "89"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "19",
      "src": "images/page_xii_7.jpg",
      "width": "401"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/page_xii_8.jpg",
      "width": "79"
    }
  }), _vm._v(", as Heracleitus has it. Wherefore the Divine is no worse represented in these animals than in works of bronze and stone, which are alike subject to destruction and disfiguration and by their nature are void of all perception"), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _vm._v(" and comprehension. This, then, is what I most approve in the accounts that are given regarding the animals held in honor."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn9",
      "id": "fnr9"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent1",
    attrs: {
      "id": "intro_p8"
    }
  }, [_vm._v("Somewhat later, under the influence of Neoplatonic currents during the first two centuries A.D., Christian writers conceived of a more systematic "), _c('img', {
    attrs: {
      "alt": "",
      "height": "20",
      "src": "images/page_xiii_1.jpg",
      "width": "93"
    }
  }), _vm._v(" with a mystical dimension nowhere to be found among the ancients. Clement of Alexandria, for example, in book 4 of his "), _c('i', [_vm._v("Stromata")]), _vm._v(" speaks of a "), _c('img', {
    attrs: {
      "alt": "",
      "height": "20",
      "src": "images/page_xiii_2.jpg",
      "width": "173"
    }
  }), _vm._v(", by which he appears to mean an initiation into the knowledge of the heavenly mysteries by way of their earthly correspondences ("), _c('img', {
    attrs: {
      "alt": "",
      "height": "17",
      "src": "images/page_xiii_3.jpg",
      "width": "301"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "17",
      "src": "images/page_xiii_4.jpg",
      "width": "88"
    }
  }), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn10",
      "id": "fnr10"
    }
  }, [_vm._v("10")])]), _vm._v(" Perhaps the clearest statement of the principle on which such a mystical "), _c('img', {
    attrs: {
      "alt": "",
      "height": "20",
      "src": "images/page_xiii_1.jpg",
      "width": "93"
    }
  }), _vm._v(" is based, however, can be found in book 3 of Origen’s "), _c('i', [_vm._v("Commentary on the Song of Songs")]), _vm._v(", the entire second half of which is dedicated to exploring the analogical structure of nature. Origen writes,")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1",
    attrs: {
      "id": "intro_p9"
    }
  }, [_vm._v("The apostle Paul teaches us that the invisible things of God may be known through the visible "), _c('i', [_vm._v("(invisibilia Dei ex visibilibus intelligantur)")]), _vm._v(", and things which are not seen may be contemplated by reason of and likeness to those things which are seen. He shows by this that this visible world may teach about the invisible and that earth may contain certain patterns of things heavenly, so that we may rise from lower to higher things "), _c('i', [_vm._v("(ut ab his, quae deorsum sunt, ad ea, quae sursum sunt, possimus adscendere)")]), _vm._v(" and out of those we see on earth perceive and know those which are in the heavens. As a certain likeness of these, the Creator has given a likeness of creatures which are on earth, by which the differences more easily might be gathered and perceived. And perhaps just as God made man in his own image and likeness, so also did he make the remaining creatures after certain other heavenly images as a likeness. And perhaps every single thing on earth has something of an image and likeness "), _c('i', [_vm._v("(habent aliquid imaginis et similitudinis in caelestibus)")]), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _vm._v(" in heavenly things, to such a degree that even the grain of mustard which is the smallest of all seeds may have something of an image and likeness in heaven."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn11",
      "id": "fnr11"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent1",
    attrs: {
      "id": "intro_p10"
    }
  }, [_vm._v("When the author of "), _c('i', [_vm._v("Physiologus")]), _vm._v(" says that we should understand the “intelligible” pearl "), _c('i', [_vm._v("(intelligibilis margarita)")]), _vm._v(" or elephant or dove, he is relying on Origen’s concept of the correspondences between the phenomenal world of nature and its heavenly archetype, of which it is a likeness "), _c('i', [_vm._v("(similitudo).")]), _vm._v(" In other words, Clement and Origen allowed the allegorical method of Philo (with the authority of Saint Paul) to be applied to the “book of nature.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn12",
      "id": "fnr12"
    }
  }, [_vm._v("12")])]), _vm._v(" As Paul said, “Ever since the creation of the world his invisible nature, namely, his eternal power and deity, has been clearly perceived in the things that have been made” (Romans 1: 20). Under the conviction that the Creator had infused nature with his traces, the Alexandrian allegorists devised a mystical hermeneutics by which man’s limited terrestrial understanding could embrace the divine. Although their theologies were very different, the Christian and pagan allegorists, especially in Egypt, shared much common ground in discerning within the operations of the natural world “a portion of the beauty of the Intelligence by which the universe is guided.” Both systems exploit certain natural processes as a symbolic language whose vocabulary itself bears an explicit correspondence to the nature of the Creator. For a Christian Platonist such as Origen, however, these "), _c('i', [_vm._v("imagines")]), _vm._v(" and "), _c('i', [_vm._v("similitudines")]), _vm._v(" were deliberately fashioned by God to lead man’s weakened intelligence to a knowledge of things hidden and spiritual. While we would not be justified to speak here of an early Christian “semiotics” of nature, since nothing so elaborate was envisioned by Clement or Origen (or by Plutarch for that matter), it is true to say that the idea of the analogic structure of nature furnished the Christian world with a ready set of divinely provided symbols to bridge the otherwise impassable intellectual gulf between the"), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _vm._v(" "), _c('i', [_vm._v("visibilia")]), _vm._v(" of this world and the "), _c('i', [_vm._v("invisibilia")]), _vm._v(" of the other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p11"
    }
  }, [_vm._v("The aim of this method was far different, too, from that of a Sophist naturalist such as Aelian (fl. A.D. 200), for whom the behavior of animals is often a model of human conduct, an opportunity for a sermon on the social harmony of the natural world, or a lament on man’s inhumanity to man; his purpose is entirely ethical and social. "), _c('i', [_vm._v("Physiologus")]), _vm._v(", to be sure, also elicits purely moral lessons from the natural world but more often aims at making manifest the nature of God himself by unveiling the vestiges of the Creator in creation. This is the justification for a Christian "), _c('img', {
    attrs: {
      "alt": "",
      "height": "20",
      "src": "images/page_xiii_1.jpg",
      "width": "93"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p12"
    }
  }, [_vm._v("Finally, in addition to the moral-mystical significance which early Christian authors gave to the ancient idea of "), _c('img', {
    attrs: {
      "alt": "",
      "height": "20",
      "src": "images/page_xiii_1.jpg",
      "width": "93"
    }
  }), _vm._v(", the term was also used by writers of the early Christian period to mean simply any allegorical interpretation of a myth or legend. Thus, Tertullian in his tract "), _c('i', [_vm._v("Ad Nationes")]), _vm._v(" interprets "), _c('i', [_vm._v("physiologice per allegoricam argumentationem")]), _vm._v(" Saturn’s devouring his children to mean that Time consumes everything that arises from it."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn13",
      "id": "fnr13"
    }
  }, [_vm._v("13")])]), _vm._v(" Somewhat later, Servius, in his commentary on line 295 of book 6 of Vergil’s "), _c('i', [_vm._v("Aeneid")]), _vm._v(", speaks of his moralized allegory of the geography of Hades as a "), _c('i', [_vm._v("physiologia."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn14",
      "id": "fnr14"
    }
  }, [_vm._v("14")])])]), _vm._v(" The mythographer Fulgentius claimed to have written a book entitled "), _c('i', [_vm._v("Physiologus")]), _vm._v(", but its precise contents are unknown to us."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn15",
      "id": "fnr15"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p13"
    }
  }, [_vm._v("I have lingered over the meaning of "), _c('i', [_vm._v("physiologia")]), _vm._v(" among the ancients and early Christians to dispel the notion that the title of our book means “the naturalist,” as we often read. "), _c('i', [_vm._v("Physiologus")]), _vm._v(" was never intended to be a treatise on natural history. For that purpose, the Middle Ages had Pliny. Nor did the word "), _c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/page_xiv_1.jpg",
      "width": "90"
    }
  }), _vm._v(" ever mean simply “the naturalist” as we understand the term, as should now be evident, but one who interpreted metaphysically, morally, and, finally, mystically the transcendent significance of the natural world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p14"
    }
  }, [_vm._v("Physiologus, no doubt, was originally understood to"), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _vm._v(" be a person, not the title of a book. The formulas "), _c('i', [_vm._v("Physiologus dicit")]), _vm._v(" and "), _c('i', [_vm._v("Bene Physiologus dixit")]), _vm._v(" show that a person is meant. Who was he? We will probably never know. The one thing that seems certain from what has been said, however, is that, to have merited his name, he must have written about the natural world in the spirit of what we know "), _c('img', {
    attrs: {
      "alt": "",
      "height": "20",
      "src": "images/page_xiii_1.jpg",
      "width": "93"
    }
  }), _vm._v(" to have meant. In any case, throughout the Medieval period Aristotle and Solomon, the Greek and Hebrew interpreters of nature "), _c('i', [_vm._v("par excellence")]), _vm._v(", were alternately identified as Physiologus. The Byzantine recension of "), _c('i', [_vm._v("Physiologus")]), _vm._v(" makes Solomon the author of the legends and Saint Basil the author of the allegory."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn16",
      "id": "fnr16"
    }
  }, [_vm._v("16")])]), _vm._v(" Among the host of other noteworthy authorities proposed at one time or another as the author of "), _c('i', [_vm._v("Physiologus")]), _vm._v(", we might mention Peter of Alexandria, Epiphanios, John Chrysostom, Athanasius, Ambrose, and Jerome.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "intro_p15"
    }
  }, [_vm._v("PLACE OF ORIGIN")]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "intro_p16"
    }
  }, [_c('b', [_vm._v("I")]), _vm._v("t has generally been accepted that Physiologus was originally produced in Egypt and, more particularly, in Alexandria for the following reasons:")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p17"
    }
  }, [_vm._v("1. A number of legends in "), _c('i', [_vm._v("Physiologus")]), _vm._v(" can be traced back to Egyptian folk beliefs and religious worship concerning sacred animals. The phoenix was, of course, the sacred bird of the city of Heliopolis, where it was worshipped as part of the cult of the sun god. The ichneumon, the niluus (or hydrus), and the crocodile were associated among the Egyptians with legends concerning the Nile and the battles of the forces of light and darkness."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn17",
      "id": "fnr17"
    }
  }, [_vm._v("17")])]), _vm._v(" The chapter on the wild ass and the monkey appears to rely on an Egyptian folk belief about the inauspiciousness of the twenty-fifth day of the month of Phamenoth. This and another Coptic month, Pharmouthi, are also mentioned in the chapter on the phoenix.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p18"
    }
  }, [_vm._v("2. Some fifteen legends are common to "), _c('i', [_vm._v("Physiologus")]), _vm._v(" and the treatise on hieroglyphics known as the "), _c('i', [_vm._v("Book of Horapollo.")]), _vm._v(" The similarity of parts of our text to the "), _c('i', [_vm._v("Kyranides")]), _vm._v(" of “Hermes Trismegistos” can be explained by the direct influence of the former on the latter and, partly, by a common dependence on a reservoir of popular Egyptian lore.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p19"
    }
  }, [_vm._v("3. The allegorical method of "), _c('i', [_vm._v("Physiologus")]), _vm._v(" ultimately reaches back to the Hellenized Jewish scholars of the schools of Alexandria and their most eloquent spokesman, Philo, from whom Christian exegetes, particularly Clement of Alexandria and Origen, derived their manner of interpreting Scriptures. The indebtedness of our text to Alexandrian hermeneutics has never been in doubt. Scholars (such as Max Wellmann) who think that "), _c('i', [_vm._v("Physiologus")]), _vm._v(" was composed in Syria by a disciple of Origen"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn18",
      "id": "fnr18"
    }
  }, [_vm._v("18")])]), _vm._v(" acknowledge its Alexandrian flavor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p20"
    }
  }, [_vm._v("4. The existence of an early Ethiopian translation of "), _c('i', [_vm._v("Physiologus")]), _vm._v(", according to its editor and translator Fritz Hommel, points to Alexandria as a source, since the overwhelming majority of the earliest Ethiopian texts are derived from Alexandrian models."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn19",
      "id": "fnr19"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p21"
    }
  }, [_vm._v("5. The well-established tradition of Alexandrian paradoxography, i.e., popular literature concerning marvels ("), _c('img', {
    attrs: {
      "alt": "",
      "height": "17",
      "src": "images/page_xvii_1.jpg",
      "width": "171"
    }
  }), _vm._v("), dates back at least to Callimachus and his contemporary, Bolos. While "), _c('i', [_vm._v("Physiologus")]), _vm._v(" is not primarily a work of paradoxography, it nevertheless shares common ground with that form of literature in its love of exotic subject matter and fabulous natural history.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "intro_p22"
    }
  }, [_vm._v("THE DATE")]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "intro_p23"
    }
  }, [_c('b', [_vm._v("T")]), _vm._v("he date of the original Greek version of "), _c('i', [_vm._v("Physiologus")]), _vm._v(" is much debated. Lauchert, who wrote the most complete study of the work, was of the opinion that it was in circulation around A.D. 140 or even during the first quarter"), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }), _vm._v(" of the second century."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn20",
      "id": "fnr20"
    }
  }, [_vm._v("20")])]), _vm._v(" The evidence for such an early date consists of what Lauchert thought to be echoes of "), _c('i', [_vm._v("Physiologus")]), _vm._v(" in the writings of the Greek church fathers. One of these is especially important. In Origen’s seventeenth homily on Genesis 4: 9, the benediction of Jacob (“Judah is a lion’s whelp; from the prey, my son, you have gone up. He stooped down, he crouched as a lion, and as a lioness; who dares rouse him up?”) the following passage appears: “A mystical exposition is provided for this passage in which the lion’s whelp represents Christ not only figuratively "), _c('i', [_vm._v("(tropice)")]), _vm._v(" but truly also by nature "), _c('i', [_vm._v("(physice)")]), _vm._v(", for Physiologus wrote the following about the lion’s whelp: after being born, it sleeps for three days, and three nights after which the sire’s growling and roaring makes the lair tremble and awakens the sleeping whelp. That other whelp, therefore, arose from the shoot, for He was born of a Virgin.” Now if Origen (ca. 185–254) did write this passage, it would be our earliest explicit mention of "), _c('i', [_vm._v("Physiologus.")]), _vm._v(" But it is now generally accepted that Rufinus, Origen’s Latin translator, interpolated this and many other such passages into the original homily sometime between A. D. 397 and 410. The echoes that Lauchert perceived in the works of Clement of Alexandria (ca. 150–215), Justin Martyr (ca. 100–165), and the pseudo-Clement of Rome "), _c('i', [_vm._v("(The Recognitions")]), _vm._v(", 211–231) cannot be received as anything more than faint reverberations of a general tradition of folklore from which they and our author commonly drew.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p24"
    }
  }, [_vm._v("At the other end of the spectrum are those scholars who suggest that "), _c('i', [_vm._v("Physiologus")]), _vm._v(" was originally composed sometime during the fourth century. Karl Ahrens, for example, thought that the warnings against heresy which are found in the Greek version of the legend of the ant, the sirens, the whale, and the coot are explainable in the light of fourth-century church history, especially the turmoil created by the Arian heresy."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn21",
      "id": "fnr21"
    }
  }, [_vm._v("21")])]), _vm._v(" Such an"), _c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _vm._v(" argument, however, is not entirely convincing, since many early Christian writers such as Justin Martyr often refer to heretics. Besides, it would not be correct to claim that "), _c('i', [_vm._v("Physiologus")]), _vm._v(" displays notable concern over the problem of heresy. In fact, the faint traces of Gnosticism discernible in the chapters on the lion, the unicorn, and the adamant-stone argue for an early date of composition, when such incipiently “heretical” doctrines were to be found among the most orthodox writers, not to mention the Scriptures themselves. It was not until 534 at the Synod of Constantinople that the Gnostic doctrine of the Incarnation, of which there are traces in "), _c('i', [_vm._v("Physiologus")]), _vm._v(", was finally condemned as one of the nine errors of Origenism."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn22",
      "id": "fnr22"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p25"
    }
  }, [_vm._v("On the other hand, Wellmann has clearly demonstrated that toward the end of the fourth century "), _c('i', [_vm._v("Physiologus")]), _vm._v(" was quoted verbatim for the first time by the author of the Hexaemeron commentary of Eustathios."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn23",
      "id": "fnr23"
    }
  }, [_vm._v("23")])]), _vm._v(" Also about this time in the Latin tradition (ca. 386–388), Saint Ambrose seems to draw directly on the wording of "), _c('i', [_vm._v("Physiologus")]), _vm._v(" in his "), _c('i', [_vm._v("Hexaemeron")]), _vm._v(" when telling the legend of the partridge. This passage in Ambrose is especially important since the partridge story does not appear in literature earlier than "), _c('i', [_vm._v("Physiologus.")]), _vm._v(" That Ambrose recounts both the legend and the allegory as they are found in our text makes it quite likely that he knew "), _c('i', [_vm._v("Physiologus")]), _vm._v(" at first hand."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn24",
      "id": "fnr24"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p27"
    }
  }, [_vm._v("The earliest translation of the Greek text appears in Ethiopian toward the beginning or middle of the fifth century A.D., and not long afterward the Syrian and Armenian versions were produced."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn25",
      "id": "fnr25"
    }
  }, [_vm._v("25")])]), _vm._v(" On purely textual grounds F. Sbordone concluded after studying seventy-seven Greek manuscripts and their genealogies that the original Greek text was composed around the year A.D. 200."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn26",
      "id": "fnr26"
    }
  }, [_vm._v("26")])]), _vm._v(" We can conclude, therefore, that the Greek text was in circulation by the last quarter of the fourth century; it may have been composed as many as two hundred"), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  }), _vm._v(" years earlier, although evidence for this opinion is by no means conclusive.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p29"
    }
  }, [_vm._v("The earliest Latin translation of "), _c('i', [_vm._v("Physiologus")]), _vm._v(" could have appeared sometime in the fourth century, if Ambrose (who knew Greek) was quoting from a Latin text in the passage on the partridge in his "), _c('i', [_vm._v("Hexaemeron.")]), _vm._v(" The allegory on the third nature of the ant in one family of Latin manuscripts warns against certain heresies: “Flee, O man of God, barley, that is the teachings of the heretics, for they are barley and harmful things fit to be cast among rocks. Heresies kill the souls of men. Flee Sabellius, Marcion, Manichaeus, avoid Novatianus, Montanus, Valentinus, Basilides, Macedonius, avoid Donatianus and Photinus and all who come forth from the Arian brood like serpentine offspring from the womb of the dragon. The dogmas of these men are false and hostile to truth.” Noticing that the name of Nestorius is absent from this list, Lauchert proposed that the Latin text must, therefore, have been composed ca. 397–431, since Nestorianism was condemned at the Council of Ephesus in 431."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn27",
      "id": "fnr27"
    }
  }, [_vm._v("27")])]), _vm._v(" While such a date for the Latin translation is not inherently improbable, the argument from omission is always open to some doubt. Perry, in fact, has pointed out that in some Latin versions of "), _c('i', [_vm._v("Physiologus")]), _vm._v(" the names of Montanus and Macedonius are also lacking and that this can be explained by scribal inattention or tampering as well as by chronology."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn28",
      "id": "fnr28"
    }
  }, [_vm._v("28")])]), _vm._v(" Sbordone’s study of the genealogy of the manuscripts led him to conclude that the Latin translation goes back to one of the oldest Greek texts, even though the earliest surviving Latin manuscripts date from the eighth (MS Bern 233), ninth (MS Bern 318), and tenth centuries (MS Wolfenbüttel Cod. Gud. 148 and MS Bruxells 10,074). The first explicit reference to a Latin "), _c('i', [_vm._v("Physiologus")]), _vm._v(" occurs in the fifth part of the so-called "), _c('i', [_vm._v("Decretum Gelasianum")]), _vm._v(", entitled “De libris recipiendis et non recipiendis.” Among the books to be shunned is one "), _c('i', [_vm._v("\"Liber Physiologus")]), _vm._v(" ab"), _c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }), _vm._v(" hereticis conscriptus et beati Ambrosii nomine praesignatus, apocryphus.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn29",
      "id": "fnr29"
    }
  }, [_vm._v("29")])]), _vm._v(" The "), _c('i', [_vm._v("Decretum Gelasianum")]), _vm._v(" purports to be an official document of Pope Gelasius (492–496); it is, however, strongly suspected of being a private compilation dating from early sixth-century Italy."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn30",
      "id": "fnr30"
    }
  }, [_vm._v("30")])]), _vm._v(" That someone during this period should think "), _c('i', [_vm._v("Physiologus")]), _vm._v(" a heretical work is perhaps not as important as the fact that subsequent orthodox writers openly ignored the prohibition (if they ever knew of it) against reading it. The Latin translation, therefore, was known in the early sixth century and quite possibly was circulating as early as the mid fourth century.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "intro_p30"
    }
  }, [_vm._v("THE SOURCES")]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "intro_p31"
    }
  }, [_vm._v("In keeping with the general uncertainty that clouds the historical background of "), _c('i', [_vm._v("Physiologus")]), _vm._v(", we know of no single “source” which provided our author with the material for his work. This fact is not altogether surprising, since a glance at the analogues provided in the notes following the translation will show that "), _c('i', [_vm._v("Physiologus")]), _vm._v(" is a syncretic work which draws upon folk legends and pseudoscience common to many Eastern Mediterranean cultures—Greek, Roman, Egyptian, Hebrew, and Indian. Some of these tales certainly date back to prehistory while others, as far as we know, appear in their classic form for the first time in the pages of "), _c('i', [_vm._v("Physiologus")]), _vm._v(" itself."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn31",
      "id": "fnr31"
    }
  }, [_vm._v("31")])]), _vm._v(" Pliny’s "), _c('i', [_vm._v("Natural History")]), _vm._v(" records many stories closely analogous to those of our text, and Aelian’s "), _c('i', [_vm._v("History of the Animals")]), _vm._v(", as has already been noted, attaches similar moral interpretations to animal behavior, real or imagined. Max Wellmann has shown that the magical-medical properties of animals, stones, and trees as described in "), _c('i', [_vm._v("Physiologus")]), _vm._v(" can be traced back to the writings of Bolos of Mendes (third century B.C.), as can the sympathy-antipathy framework of many of the legends in "), _c('i', [_vm._v("Physiologus")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn32",
      "id": "fnr32"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p32"
    }
  }, [_vm._v("Some early students of "), _c('i', [_vm._v("Physiologus")]), _vm._v(" regarded the book as consisting of two distinct parts: the legends and the allegories. The existence of a number of versions containing only the legends led some scholars to conclude that the two parts were in fact written independently."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn33",
      "id": "fnr33"
    }
  }, [_vm._v("33")])]), _vm._v(" The legends, according to this view, were first compiled into a pseudoscientific medley by a pagan author who drew on the well-known literary sources of ancient natural history from Herodotus and Aristotle down through Pliny and Aelian. To this collection, a Christian writer familiar with the allegorical exegesis of the Alexandrian school attached the interpretations as we now have them. The intention of the author was to render "), _c('i', [_vm._v("physiologice per allegoricam argumentationem")]), _vm._v(" the true kernel of meaning within the integument of a pagan fable. Or, to paraphrase Saint Paul, the author set about to let us see face to face what the ancients perceived only through a glass darkly. As we have seen already, this view had its advocates during the later Middle Ages among those who thought that Solomon or Aristotle was responsible for the legends and that Saint Basil was the author of the allegories. The general view was that the author played a passive role in collecting the preexistent legends and an active one in composing their interpretations. There is something to be recommended in this view. The legend of the beaver, for example, is told among other places in Pliny’s "), _c('i', [_vm._v("Natural History (8.")]), _vm._v(" 109): “The beavers of the Black Sea region practice self-amputation of the same organ [i.e., their genitals] when beset by danger, as they know that they are hunted for the sake of its secretion, the medical name for which is beaver-oil.” Now the ancient poets were not slow to perceive a moral in that story. Juvenal uses the beaver as a symbol of prudence in "), _c('i', [_vm._v("Satire")]), _vm._v(" 12. 29f., where he portrays the wealthy Catullus in the midst of a potential shipwreck jettisoning his luxurious possessions into the sea to preserve his life at the expense of his cargo, just"), _c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }), _vm._v(" as the wise beaver casts off his genitals to preserve his life. This story survived scientific protestations against its accuracy and was repeated by Herodotus and Aesop among the Greeks and by Cicero and Apuleius among the Latins."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn34",
      "id": "fnr34"
    }
  }, [_vm._v("34")])]), _vm._v(" Now the version of the beaver’s self-castration which appears in "), _c('i', [_vm._v("Physiologus")]), _vm._v(" does not appear to have been altered substantially from its ancient analogues. The animal’s mildness "), _c('i', [_vm._v("(innocentissimum valde et quietum)")]), _vm._v(" is mentioned by way of assimilation with the previous chapter on the unicorn. The mention of his second escape from the hunters has been borrowed from Aelian’s version "), _c('i', [_vm._v("(On Animals")]), _vm._v(" 6. 34), where the detail first appears. For the most part, however, our author found the traditional story consonant with Christian morality and hence in no need of manipulation before “attaching” the allegory. The beaver is every true Christian, the hunter is the devil (a common metaphor in the Middle Ages), the beaver’s genitals are the inclinations toward sin in all of us, and the entire legend illustrates Saint Paul’s admonition in Romans 13: 7, “Pay all of them their dues, taxes to whom taxes are due, honor to whom honor is due, etc.” With a deft application of hermeneutics, an ancient legend is transformed into a Christian fable. Since the details of the ancient legend are left largely intact in "), _c('i', [_vm._v("Physiologus")]), _vm._v(", we can properly speak of the allegory in this case being appended to a pagan model. In most cases, however, the author plays a far less passive role in transmitting the conventional legend.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p33"
    }
  }, [_vm._v("A good example of how wholly new details insinuate themselves into "), _c('i', [_vm._v("Physiologus’s")]), _vm._v(" legends can be found in the description of the first nature of the serpent. When this animal grows old, its eyes become dim. Wanting to renew itself, it fasts for forty days and forty nights; when its skin has become loosened from its flesh, it finds a narrow crack "), _c('i', [_vm._v("(fissura angusta)")]), _vm._v(" in a rock and, squeezing itself through the crack, casts off its skin and"), _c('a', {
    attrs: {
      "id": "page_xxiv"
    }
  }), _vm._v(" is thus rejuvenated. Now a very similar legend is told of the serpent in the ancient analogues, especially in pliny and Aelian."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn35",
      "id": "fnr35"
    }
  }, [_vm._v("35")])]), _vm._v(" There are some revealing differences, however: nowhere does either ancient writer mention that the serpent “fasts” for forty days and nights. Pliny states in one passage (8. 59) that a serpent can endure a hibernation of a year without food, provided that it is protected against the cold. Elsewhere (8. 41) he says that the snake’s sloughing requires at least twenty-four hours to complete. The fast of forty days, however, was suggested to our author by Matthew 4: 2, where Christ is said to have fasted forty days and forty nights in the desert immediately following his baptism and just before his temptation by the devil. Similarly, although both Aelian and Pliny mention the serpent’s hibernation in a hole, neither suggests that the sloughing occurs as a result of the animal’s emergence through a “narrow crack” in the ground. This embellishment is entirely the work of a Christian author purposely echoing the language of Matthew 7: 14, “The gate is narrow ("), _c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/page_xxiv_1.jpg",
      "width": "137"
    }
  }), _vm._v(") and there is tribulation on the way which leads toward life, and few are those who enter through it.” On one level, the legend of the snake’s rejuvenation has been metamorphosed into a quadragesimal allegory of one of the episodes in the life of Christ. On another level, it represents the struggle of the soul of every Christian to overcome the burden of the flesh and to attain a state of purification. Again, only in "), _c('i', [_vm._v("Physiologus")]), _vm._v(" do we find mention of the old age of the snake. Sbordone"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn36",
      "id": "fnr36"
    }
  }, [_vm._v("36")])]), _vm._v(" suggests that this detail arises from a misunderstanding of the Greek expression "), _c('img', {
    attrs: {
      "alt": "",
      "height": "17",
      "src": "images/page_xxiv_2.jpg",
      "width": "160"
    }
  }), _vm._v(", meaning “to slough off a vestigial layer of skin” ("), _c('img', {
    attrs: {
      "alt": "",
      "height": "17",
      "src": "images/page_xxiv_3.jpg",
      "width": "72"
    }
  }), _vm._v("), and not “to put off or cast off old age” (since "), _c('img', {
    attrs: {
      "alt": "",
      "height": "17",
      "src": "images/page_xxiv_3.jpg",
      "width": "72"
    }
  }), _vm._v(" can also mean “old age\"). From what has been said thus far, however, it seems more likely that this departure from the analogues is a deliberate intervention on the part of the author to create an"), _c('a', {
    attrs: {
      "id": "page_xxv"
    }
  }), _vm._v(" “enigma of the Divine” where nature and art provided none. And what of the serpent’s blindness? It is cured according to the ancients by the beast’s rubbing its eyes against the fennel plant, of which there is no mention in "), _c('i', [_vm._v("Physiologus.")]), _vm._v(" The absence of this therapeutic plant introduces some doubt into the reader’s mind whether the beast remains blind following its sloughing or its eyesight is restored with its new skin. Nevertheless, there can be little doubt that the language of the entire first nature of the serpent is reminiscent of Saint Paul’s words to the Colossians 3: 9 and the Ephesians 4: 22: “Put off your old nature… and put on the new nature created after the likeness of God in true righteousness and holiness.” In working to enhance the legend’s moral and mystical content, our author sacrifices some of the scientific details of the tradition, leaving a narrative rough edge here and there. But his general purpose remains clear: to conform the“facts” of the visible operations of nature to their “intelligible” archetypes in accord with Christian "), _c('img', {
    attrs: {
      "alt": "",
      "height": "20",
      "src": "images/page_xiii_1.jpg",
      "width": "93"
    }
  }), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p34"
    }
  }, [_vm._v("Not only are the details of many legends purposely altered to harmonize them with Christian doctrine, but the very substance of some stories has been subjected in "), _c('i', [_vm._v("Physiologus")]), _vm._v(" to a radical metamorphosis for the same purpose. Ancient authorities tell us that the panther (in Aelian it is the leopard, "), _c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/page_xxv_1.jpg",
      "width": "91"
    }
  }), _vm._v(") gives off a marvelous fragrance which attracts all animals."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn37",
      "id": "fnr37"
    }
  }, [_vm._v("37")])]), _vm._v(" Because he is a fearsome beast to behold, he lurks in the underbrush unseen by his unsuspecting prey as they are irresistibly drawn to his sweet odor. Once within range, he springs upon them suddenly and devours them. Although the details vary from author to author, all the ancients agree that the panther is a predator who uses his fragrance as a deadly enticement."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn38",
      "id": "fnr38"
    }
  }, [_vm._v("38")])]), _vm._v(" He is, in other words, an example of one of the “antipathies” of the natural world, since he is an enemy of all other beasts. The story as we find it in "), _c('i', [_vm._v("Physiologus")]), _vm._v(", however, has undergone a number"), _c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  }), _vm._v(" of interpolations calculated to turn the animal’s traditional symbolic value from one of universal antipathy to one of universal sympathy (excepting the hostility toward the dragon, of course), thus reversing the original point of the legend. The panther now becomes a mild animal "), _c('i', [_vm._v("(quietum…et mitissimum)")]), _vm._v(" whose coat is beautiful and variegated. Awakening from sleep after three days, he roars and breathes forth a pleasant fragrance "), _c('i', [_vm._v("(odor bonus aromatum)")]), _vm._v(" which causes all beasts far and near to follow him. In this case, the legend reverberates with echoes of the New Testament. No phrase is without allegorical significance, even such parenthetical phrases as “those who are far and near” "), _c('i', [_vm._v("(qui longe sunt et qui prope)")]), _vm._v(", by which we are to understand the Gentiles who are far away without the Law and the Jews who are near living within the Law.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p35"
    }
  }, [_vm._v("Many other chapters could be cited in detail to show how the author of "), _c('i', [_vm._v("Physiologus")]), _vm._v(" has reshaped the traditional material of his analogues to conform to a preconceived allegory. Sometimes this refashioning is accomplished at the expense of narrative logic, as we have seen in the case of the blindness of the serpent. But, in most cases, the author has succeeded in retelling the old tales with the spirit "), _c('i', [_vm._v("and")]), _vm._v(" letter of the Christian Scriptures. Behind "), _c('i', [_vm._v("Physiologus")]), _vm._v(" there may have been a pseudoscientific anthology from which our author derived his lore, but there can be little doubt that in transmitting these legends he transformed them in the interest of Christian doctrine and within the conceptual framework of a Christian Neoplatonic "), _c('img', {
    attrs: {
      "alt": "",
      "height": "20",
      "src": "images/page_xiii_1.jpg",
      "width": "93"
    }
  }), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "intro_p36"
    }
  }, [_vm._v("THE LATER HISTORY OF "), _c('i', [_vm._v("Physiologus")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "intro_p37"
    }
  }, [_c('b', [_vm._v("T")]), _vm._v("he influence of "), _c('i', [_vm._v("Physiologus")]), _vm._v(" on the literature and art of the later Middle Ages is too long a story to be fully recounted here. Its impact on literature begins with the earliest translation of the Greek text into Ethiopian toward"), _c('a', {
    attrs: {
      "id": "page_xxvii"
    }
  }), _vm._v(" the beginning or middle of the fifth century. The value of the Ethiopian translation, apart from its being one of the earliest literary works extant in that language, is its apparent fidelity to the Greek original."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn39",
      "id": "fnr39"
    }
  }, [_vm._v("39")])]), _vm._v(" Probably as old as the Ethiopian version is the Armenian, which stems from a fourth-century Greek manuscript; it agrees closely with the Greek in most of the legendary details, although the allegories show marked variation from the original. The Armenian translation contains thirty-five beasts, of which three appear in no known Greek model (the Zerehav bird, the bee, and the tiger). As old as the Ethiopian and Armenian versions is the Old Syrian translation, in which the allegories and in some cases the Biblical citations are abandoned. Although the Syrian translator appears to have understood Greek better than his Ethiopian and Armenian contemporaries, he did not hesitate to draw upon sources outside "), _c('i', [_vm._v("Physiologus")]), _vm._v(" in at least one instance, the story of the ostrich. The impulse to expand the inventory of "), _c('i', [_vm._v("Physiologus")]), _vm._v(" begins in these early translations. Land’s edition of the Syrian version, for example, contains eighty-one chapters, of which only the first forty-seven are taken from "), _c('i', [_vm._v("Physiologus;")]), _vm._v(" the rest have been borrowed from Basil’s "), _c('i', [_vm._v("Hexaemeron.")]), _vm._v(" It is also at this time that attempts to identify the author begin. The title of Land’s edition reads, “…liber Physiologi sive verba facientis de naturis, et compositus est a S. Basilio, cum theoria sive expositione ex illis "), _c('i', [_vm._v("deprompta.“")]), _vm._v(" This tradition of attribution was followed in later centuries when authorities such as Ambrose, Chrysostom, Epiphanios, and Jerome, all of whom wrote on natural history and were often indebted to "), _c('i', [_vm._v("Physiologus")]), _vm._v(", were proposed as authors of our book. There are two Arabic translations of "), _c('i', [_vm._v("Physiologus")]), _vm._v(", one containing only eleven chapters, the other only thirty-five. The latter translation follows the Ethiopian order of chapters and probably reaches back to a very early Greek model. Its heading attributes the original to"), _c('a', {
    attrs: {
      "id": "page_xxviii"
    }
  }), _vm._v(" “Gregorius Theologus” (i.e., Gregory of Nazianzus). Probably during the eighth century a Georgian translation appeared which was the archetype (now lost) of the surviving tenth-century Georgian version.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p38"
    }
  }, [_vm._v("The earliest Latin "), _c('i', [_vm._v("Physiologus")]), _vm._v(", as indicated above, appears sometime between the fourth and the sixth centuries, although the earliest surviving manuscripts date from the eighth, ninth, and tenth centuries. The Latin translations are usually characterized by an expanded allegory (see chapter XXIV, “On the Oyster-stone and the Pearl“). Association of the elephant with the Samaritan, the interpretation of the many colors of the doves, and the independent chapter on the viper all arise from the enlarged allegories in the Latin texts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p39"
    }
  }, [_vm._v("Excerpted versions of "), _c('i', [_vm._v("Physiologus")]), _vm._v(" begin to appear with the so-called alphabetical "), _c('i', [_vm._v("Glossary of Ansileubus")]), _vm._v(", which omits the allegories."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn40",
      "id": "fnr40"
    }
  }, [_vm._v("40")])]), _vm._v(" Similarly, the so-called "), _c('i', [_vm._v("Dicta Chrysostomi")]), _vm._v(" (see Lauchert, pp. 92–94), from which many of the German translations stem, contains only thirty-two chapters and entirely omits stones and plants from its inventory. The earliest manuscript of the "), _c('i', [_vm._v("Dicta Chrysostomi")]), _vm._v(" dates from the eleventh century, although Chrysostom was known as the author of a “liber de natura” as early as the sixth century. From the "), _c('i', [_vm._v("Dicta Chrysostomi")]), _vm._v(" arises the so-called "), _c('i', [_vm._v("Theobaldus-Physiologus,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn41",
      "id": "fnr41"
    }
  }, [_vm._v("41")])])]), _vm._v(" a metrical version probably of the eleventh century which describes thirteen animals, including an original chapter on the spider. This version was very popular during the Middle Ages, when it was used as a school-book complete with glosses and commentary. No doubt, when certain authors during the late Middle Ages quote "), _c('i', [_vm._v("Physiologus")]), _vm._v(" as an authority, they are thinking of the author they read as schoolboys, who in many cases was Theobaldus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p40"
    }
  }, [_vm._v("The earliest European vernacular version of "), _c('i', [_vm._v("Physiologus")]), _vm._v(", and surely the most inspired, is the Old English poetic text dating from the second half of the eighth"), _c('a', {
    attrs: {
      "id": "page_xxix"
    }
  }), _vm._v(" century and sometimes attributed to Cynewulf."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn42",
      "id": "fnr42"
    }
  }, [_vm._v("42")])]), _vm._v(" Three beasts are described—the panther, the whale (called the “Fastitocalon“), and a bird, probably the partridge—for which only sixteen lines of the allegory are preserved. Perhaps the Old English poem as we have it is only a fragment of a complete translation of "), _c('i', [_vm._v("Physiologus")]), _vm._v(", since the three beasts described appear in exactly this order in the Latin text. Quite possibly, however, this selection represents a conscious attempt on the part of the Old English poet to create a triptych of nature displaying the powers of the denizens of land, sea, and air. In any case, the poet’s exquisite embroidery on the traditional legends demonstrates his independence from the received material. This same freedom of interpretation with regard to "), _c('i', [_vm._v("Physiologus")]), _vm._v(" is characteristic of its reception during the Middle Ages. Just as Physiologus itself, as we have seen, was a product of diverse tributaries, so too its branches in the course of its long journey through history never preserve the exact contours of the source. This was a book of inspiration as well as information. In Old English of about 750–800 is another poem attributed to Cynewulf on the subject of the phoenix, but its source is Lactantius’s poem "), _c('i', [_vm._v("De ave phoenice.")]), _vm._v(" Finally, two Old High German translations of the "), _c('i', [_vm._v("Dicta Chrysostomi")]), _vm._v(" version date from the eleventh and twelfth centuries, and we also have fragments in Flemish, Icelandic (of the thirteenth century), Provençal, Russian, and Medieval Greek.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p41"
    }
  }, [_vm._v("A major watershed in the later history of "), _c('i', [_vm._v("Physiologus")]), _vm._v(" is its incorporation into the encyclopedias and natural-historical compendia of the late Middle Ages. Isidore of Seville’s great "), _c('i', [_vm._v("Etymologies")]), _vm._v(" (ca. 623) transmitted an enormous volume of animal lore in book 12, entitled “De animalibus.” Isidore’s sources included an impressive number of ancient authors and church fathers, from whom he derived much material common to "), _c('i', [_vm._v("Physiologus.")]), _vm._v(" He omits the allegories, however. In addition to"), _c('a', {
    attrs: {
      "id": "page_xxx"
    }
  }), _vm._v(" Isidore, the late Middle Ages came to know the animal legends originally popularized by "), _c('i', [_vm._v("Physiologus")]), _vm._v(" in the influential works of Thomas of Cantimpré, Albertus Magnus, Vincent of Beauvais, the pseudo—Hugh of Saint Victor, Alexander Neckam, Jacques de Vitry, Bartholomeus Anglicus, and Honorius of Autun.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p42"
    }
  }, [_vm._v("By the end of the twelfth century a new form of popular nature-book had developed under the generic name of “the bestiary” which, in keeping with the encyclopedic taste of the period, tended to absorb virtually all animal legends, including those of "), _c('i', [_vm._v("Physiologus")]), _vm._v(", into its pages. While the Latin text of "), _c('i', [_vm._v("Physiologus")]), _vm._v(" contains about fifty chapters, the greatly expanded bestiaries contain as many as one hundred and fifty chapters. The bestiaries are frequently divided into zoological categories of mammals, birds, fish, reptiles, etc., and often carryover the etymological learning of Isidore, informing us, for example, that the viper "), _c('i', [_vm._v("(vipera)")]), _vm._v(" is so named because it gives birth with violence "), _c('i', [_vm._v("(vi)")]), _vm._v(", that the phoenix derives its name from its purple color "), _c('i', [_vm._v("(phoeniceus)")]), _vm._v(", and that the beaver is called "), _c('i', [_vm._v("castor")]), _vm._v(" because of its self-castration. In many instances, chapters derived from "), _c('i', [_vm._v("Physiologus")]), _vm._v(" in the bestiaries still begin and end with the formulas, “Physiologus says of the…” and “Physiologus spoke well of the…”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p43"
    }
  }, [_vm._v("It is true to say that direct knowledge of "), _c('i', [_vm._v("Physiologus")]), _vm._v(" was somewhat diluted by the enormous popularity of Isidore and the bestiaries among writers and of Honorius among artists. Most people, however, credited to "), _c('i', [_vm._v("Physiologus")]), _vm._v(" whatever animal lore was not explicitly attributable to Pliny, Aesop, Phaedrus, and Avienus. In most cases, in fact, it is very difficult to prove a single “source” for a given representation of an animal legend during the late Middle Ages. Yet we should keep in mind that, whatever the intermediaries, "), _c('i', [_vm._v("Physiologus")]), _vm._v(" was responsible ultimately for some of the most enduring iconography of Christianity. The symbolic lion, unicorn,"), _c('a', {
    attrs: {
      "id": "page_xxxi"
    }
  }), _vm._v(" panther, phoenix, whale, and pelican, which are so familiar to us, all trace their ancestry back to our little book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p44"
    }
  }, [_vm._v("In addition to Latin works, "), _c('i', [_vm._v("Physiologus")]), _vm._v(" had a forceful impact on the popular French bestiaries produced between 1125 and 1225 by Philippe de Thaon, Gervaise, Guillaume Ie Clerc, and Pierre de Beauvais. According to Florence McCulloch, most French bestiaries can be shown to derive from a version of "), _c('i', [_vm._v("Physiologus")]), _vm._v(" containing much material borrowed from Isidore. The oldest French bestiary (3,194 lines) was composed by the Anglo-Norman poet Philippe de Thaon ca. 1121 and dedicated to Aelis de Louvain, the second wife of Henry I. This work contains thirty-eight chapters treating beasts, birds, and stones in that order. Philippe cites as his sources "), _c('i', [_vm._v("Phisiologus bestiaire")]), _vm._v(" or "), _c('i', [_vm._v("bestiaire, un livre de gramaire, Ysidre")]), _vm._v(" (Le., Isidore), and "), _c('i', [_vm._v("Escripture")]), _vm._v(", though it is probably his immediate Latin model rather than direct knowledge that accounts for these sources. The importance of Philippe’s translation lies not so much in its inherent literary qualities but, as Florence McCulloch states, “in the fact that a tradition already ancient and rich had now entered the vernacular to become widely read and known in the next century and a half.“"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn43",
      "id": "fnr43"
    }
  }, [_vm._v("43")])]), _vm._v(" Gervaise’s rhymed "), _c('i', [_vm._v("Bestiaire")]), _vm._v(" (1,280 lines) was probably composed toward the beginning of the thirteenth century and follows the "), _c('i', [_vm._v("Dicta Chrysostomi")]), _vm._v(" version of "), _c('i', [_vm._v("Physiologus.")]), _vm._v(" Perhaps the most literary of the French bestiaries is that of the early thirteenth-century Norman poet Guillaume le Clerc or Guillaume Ie Normand, whose work consists of some 3,426 octosyllabic lines. Guillaume’s poem was copied repeatedly and illustrated amply down through the fifteenth century and must have been one of the principal vehicles in the vernacular for transmitting the lore of "), _c('i', [_vm._v("Physiologus")]), _vm._v(" to the later Middle Ages. Pierre de Beauvais’s bestiary, composed before 1218, exists in two renditions—a short version of twenty-eight chapters"), _c('a', {
    attrs: {
      "id": "page_xxxii"
    }
  }), _vm._v(" and a long version of about seventy-one chapters, the latter in the Picard dialect.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p45"
    }
  }, [_vm._v("Finally, mention should be made of the fourteenth-century Waldensian bestiary containing fifty-four chapters, of which some twenty-five derive from "), _c('i', [_vm._v("Physiologus. "), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn44",
      "id": "fnr44"
    }
  }, [_vm._v("44")])]), _vm._v("%")]), _vm._v(" This collection appears to have been composed for student use by one Jaco and is a very free translation, drawing on a number of sources outside "), _c('i', [_vm._v("Physiologus.")]), _vm._v(" In keeping with a common late Medieval attitude to the allegories, the Waldensian version tends to replace the mystical interpretations of the original with moral ones. Italian bestiaries appear in Tuscan during the mid thirteenth century, while the "), _c('i', [_vm._v("Bestiario moralizato")]), _vm._v(", a sonnet sequence, appears slightly later. The "), _c('i', [_vm._v("Fiori di virtú")]), _vm._v(" dates perhaps from the beginning of the fourteenth century and contains a dozen chapters, out of a total of thirty-five, from "), _c('i', [_vm._v("Physiologus.")]), _vm._v(" Having been translated into Greek, Armenian, Rumanian, Serbian, German, French, and Spanish, the "), _c('i', [_vm._v("Fiori di virtú")]), _vm._v(" is an important link in the indirect transmission of our text.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p46"
    }
  }, [_vm._v("It should be noted that, although "), _c('i', [_vm._v("Physiologus")]), _vm._v(" was one of the most popular handbooks of the Middle Ages, its legends and allegories were never received as “canonical” by later writers. Augustine for one was skeptical of the edifying legend of the pious pelican. In the very synthetic spirit of the work itself, the material was constantly manipulated to suit particular audiences. After narrating his version of the story of the frogs, the monk who composed the Byzantine recension of "), _c('i', [_vm._v("Physiologus")]), _vm._v(" draws the following startling observation in his allegory: “Thus are the majority of monks, who no sooner does a temptation grip them, but they allow themselves to become agitated with chattering and cry out, ‘We have no rest in this monastery. Our prior does not take care of us, and our confreres scorn us…. Let us go off to another monastery where we might be bosses over others rather than the other way around.’”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn45",
      "id": "fnr45"
    }
  }, [_vm._v("45")])]), _vm._v(" As with most"), _c('a', {
    attrs: {
      "id": "page_xxxiii"
    }
  }), _vm._v(" books which have made a difference in the way we think, "), _c('i', [_vm._v("Physiologus")]), _vm._v(" became all things to all men.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "intro_p47"
    }
  }, [_vm._v("THE TRANSLATION")]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "intro_p48"
    }
  }, [_c('b', [_vm._v("T")]), _vm._v("he present translation is based on the two editions of the Latin "), _c('i', [_vm._v("Physiologus")]), _vm._v(" prepared by Francis Carmody (see Bibliography), the y- and the b-version. I have relied primarily on the y-version since it is generally agreed to be the closer of the two to the Greek original. Whenever important additions or variations are supplied by the b-version, however, I have translated them and put them in square brackets. It is astonishing but true that, outside the “Theobaldus” version, the Latin "), _c('i', [_vm._v("Physiologus")]), _vm._v(" has never been translated into English. Francis Carmody’s translation for the Book Club of California is a “composite” text of the Greek, Syrian, Ethiopian, and Latin, while Carlill’s is based on the Greek. T. H. White’s "), _c('i', [_vm._v("The Book of Beasts")]), _vm._v(" is, of course, not "), _c('i', [_vm._v("Physiologus")]), _vm._v(" but a translation of the twelfth-century bestiary edited for the Roxburghe Club in 1928 by M. R. James. It appeared evident to me that a reliable translation of the Latin "), _c('i', [_vm._v("Physiologus")]), _vm._v(" was in order as this was the version common to Western Europe throughout the Middle Ages.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxxiv"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead3",
    attrs: {
      "id": "intro_p49"
    }
  }, [_vm._v("NOTES")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p50"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr1",
      "id": "fn1"
    }
  }, [_vm._v("1")]), _vm._v(". The most comprehensive survey of "), _c('i', [_vm._v("Physiologus’s")]), _vm._v(" general background and later influence remains F. Lauchert, "), _c('i', [_vm._v("Geschichte des Physiologus")]), _vm._v(" (Strassburg: Verlag Karl J. Trübner, 1889). Lauchert’s study may be complemented by the studies of such later scholars as Florence McCulloch, Francis Klingender, Beryl Rowland, and Nikolaus Henkel (see Bibliography).")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p51"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr2",
      "id": "fn2"
    }
  }, [_vm._v("2")]), _vm._v(". On the importance of paradoxography and medical-magical books in the transmission of "), _c('i', [_vm._v("Physiologus’s")]), _vm._v(" legends, see the detailed study by Max Wellmann, “Der "), _c('i', [_vm._v("Physiologos")]), _vm._v(", Eine religionsgeschichtlichnaturwissenschaftliche Untersuchung,” "), _c('i', [_vm._v("Philologus")]), _vm._v(", Supplementband 22, Heft 1 (1930): 1–116.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p52"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr3",
      "id": "fn3"
    }
  }, [_vm._v("3")]), _vm._v(". One of the most popular versions of "), _c('i', [_vm._v("Physiologus")]), _vm._v(" was the “Theobaldus version” (late eleventh or early twelfth century), which was used as a school text sometimes provided with commentary during the later Middle Ages. See P. T. Eden, ed. and trans., "), _c('i', [_vm._v("Theobaldi “Physiologus”")]), _vm._v(" (Leiden: E. J. Brill, 1972). For a Waldensian redaction, see Alfons Mayer, “Der Waldensiche "), _c('i', [_vm._v("Physiologus,” Romanische Forschungen 5")]), _vm._v(" (1890): 392–418. On the use of animal legends in preaching, see G. R. Owst, "), _c('i', [_vm._v("Literature and Pulpit in Medieval England")]), _vm._v(" (Oxford: Basil Blackwell, 1966), pp. 196–204.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p53"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr4",
      "id": "fn4"
    }
  }, [_vm._v("4")]), _vm._v(". The Icelandic translation contains only the allegories. The absence of the legends might have been compensated for by the manuscript’s rough drawings depicting the narrative matter. See Halldor Hermannson, "), _c('i', [_vm._v("The Icelandic Physiologus, Facsimile Edition")]), _vm._v(", Icelandica, vol. 27 (Ithaca, N. Y.: Cornell University Press, 1938), esp. pp. 8–9.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p54"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr5",
      "id": "fn5"
    }
  }, [_vm._v("5")]), _vm._v(". Strabo (14· 1. 7) follows Aristotle in identifying the "), _c('img', {
    attrs: {
      "alt": "",
      "height": "17",
      "src": "images/page_xxxiv_1.jpg",
      "width": "89"
    }
  }), _vm._v(" with the pre-Socratics. In his description of Miletus, for example, he mentions Thales as the first to begin the study of "), _c('img', {
    attrs: {
      "alt": "",
      "height": "20",
      "src": "images/page_xiii_1.jpg",
      "width": "93"
    }
  }), _vm._v(" among the Greeks.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxxv"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p55"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr6",
      "id": "fn6"
    }
  }, [_vm._v("6")]), _vm._v(". Diodorus Siculus 5. 40. 1–2.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p56"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr7",
      "id": "fn7"
    }
  }, [_vm._v("7")]), _vm._v(". Plutarch "), _c('i', [_vm._v("On Isis and Osiris")]), _vm._v(" 381B.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p57"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr8",
      "id": "fn8"
    }
  }, [_vm._v("8")]), _vm._v(". Ibid. 381 B.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p58"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr9",
      "id": "fn9"
    }
  }, [_vm._v("9")]), _vm._v(". Ibid. 382B–C.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p59"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr10",
      "id": "fn10"
    }
  }, [_vm._v("10")]), _vm._v(". Clemens Alexandrinus Zweiter Band Stromata, Buch I–VI, herausgegeben…von Dr. Otto Sfählin (Leipzig: J. C. Hinrichs, 1906), p. 249.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p60"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr11",
      "id": "fn11"
    }
  }, [_vm._v("11")]), _vm._v(". "), _c('i', [_vm._v("Origenes Werke")]), _vm._v(", herausgegeben…von Prof. Dr. W. A. Baehrens (Leipzig: J. C. Hinrichs, 1925), p. 208. Origen also uses Paul’s words, however, as a warning against idolatry of animal statues: “Ex hoc ergo inexcusabiles fiunt: quia cum manifestante Deo cognoverint Deum, non ut dignum est coluerunt, aut gratias egerunt; sed per cogitationum suarum vanitatem, dum formas et imagines requirunt in Deo, in semetipsis Dei imaginem perdiderunt, et qui jactare se in luce sapientiae videbantur, in profundas stultitiae tenebras devoluti sunt. Quid enim tam tetrum, tam obscurum, tamque tenebrosum, quam gloriam Dei ad corporalem et corruptibilem humanae formae effigiem vertere, ut moris est hiis qui simulacra venerantur, et divinae majestatis eminentiam volucribus, et quadrupedibus, et serpentibus exaequare?” "), _c('i', [_vm._v("(Comment. in Epist. Ad Rom. Lib.")]), _vm._v(" I [Migne, PC 14. 864]). On the other hand, the defense of animal symbolism as being opposed to idolatry is usually based among early Christian writers on Scriptures which often rely on such metaphoric language. Origen "), _c('i', [_vm._v("(On the Wisdom of Solomon")]), _vm._v(" 7. 17–21) observes: “Secundum haec intellige mihi etiam illud, quod ait: ‘Naturas animalium irasque bestiarum’; nisi enim bene scisset ‘naturas animalium,’ numquam dixisset in evangeliis Salvator: ‘dicite vulpi huic’ neque Iohannes de quibusdam dixisset: ‘serpentes generatio viperarum,’ sed neque propheta diceret de nonnullis quod: ‘equi admissarii facti sunt’ et item alius: ‘homo cum in honore esset, non intellexit; comparatus est iumentis insipientibus et similis factus est iBis’” (Baehrens, ed., p. 211).")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p61"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr12",
      "id": "fn12"
    }
  }, [_vm._v("12")]), _vm._v(". The analogy between the “scripture” of the natural"), _c('a', {
    attrs: {
      "id": "page_xxxvi"
    }
  }), _vm._v(" world and Holy Scripture occurs in Origen: “Ita igitur cuncta secundum ea, quae prefati sumus, ex visibilibus referri possunt ad invisibilia et a corporalibus ad incorporea et a ‘manifestis’ ad ‘occulta,’ ut ipsa creatura mundi tali quadam dispensatione condita intelligatur per divinam sapientiam, quae rebus ipsis et exemplis invisibilia nos de visibilibus doceat et a terrenis nos transferat ad caelestia. Haec autem rationes non solum in creaturis omnibus habentur, sed et ipsa scriptura divina tali quadam sapientiae arte conscripta est.” (Baehrens, ed., pp. 211–212). For a discussion of this passage, see Jacques Chênevert, "), _c('i', [_vm._v("L’Église dans Ie Commentaire d’Origène sur Ie Cantique des Cantiques")]), _vm._v(", Studia Travaux de recherche, vol. 24 (Brussels: Desclée de Brouwer, 1969), pp. 88–91. Philo, the great Hellenized Jewish exegete, lived ca. 13 B.C. to ca. A.D. 50 at Alexandria and established the allegorical method of interpreting Holy Scripture.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p62"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr13",
      "id": "fn13"
    }
  }, [_vm._v("13")]), _vm._v(". “Sed eleganter quidam sibi videntur physiologice per allegoricam argumentationem de Saturno inter-pretari, tempus esse, et ideo Coelum et Terram parentes, ut et ipsos origini nullos, et ideo falcatum, quia tempore omnia dirimantur, et ideo voratorem suorum, quod omnia ex se edita in se ipsum consumat” (Migne, "), _c('i', [_vm._v("PL")]), _vm._v(" 1. 674).")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p63"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr14",
      "id": "fn14"
    }
  }, [_vm._v("14")]), _vm._v(". “Nam physiologia hoc habet, quia qui caret gaudio sine dubio tristis est. Tristia autem vicina luctui est, qui procreatur ex morte: unde haec esse apud inferos dicit” "), _c('i', [_vm._v("(Servii Grammatici qui feruntur In Virgilii Carmina Commentarii recenserunt Georgius Thilo et Hermanus Hagen")]), _vm._v(", vol. 2 [Leipzig: B. G. Teubner, 19 2 3], p. 53)·")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p64"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr15",
      "id": "fn15"
    }
  }, [_vm._v("15")]), _vm._v(". Rudolph Helm, ed., "), _c('i', [_vm._v("Fabii Planciadis Fulgentii")]), _vm._v(" V. C. "), _c('i', [_vm._v("Opera")]), _vm._v(" (Stuttgart: B. G. Teubner, 197°),9 2. 1, 5.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p65"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr16",
      "id": "fn16"
    }
  }, [_vm._v("16")]), _vm._v(". Francesco Sbordone, ed., "), _c('i', [_vm._v("Physiologi Graeci singulas variarum aetatum recensiones")]), _vm._v("…"), _c('i', [_vm._v("in lucem protulit")]), _vm._v(" F. "), _c('i', [_vm._v("Sbordone")]), _vm._v(" (Milan: In Aedibus Societatis “Dante Alighieri-Alberighi, Segati et C.,” 1936), p. 196.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p66"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr17",
      "id": "fn17"
    }
  }, [_vm._v("17")]), _vm._v(". See Emma Brunner-Traut, “Altägyptische Mythenim"), _c('a', {
    attrs: {
      "id": "page_xxxvii"
    }
  }), _vm._v(" "), _c('i', [_vm._v("Physiologus,” Antaios")]), _vm._v(", Band 10,2 (July 1968): 184–198.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p67"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr18",
      "id": "fn18"
    }
  }, [_vm._v("18")]), _vm._v(". Wellmann, p. 13.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p68"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr19",
      "id": "fn19"
    }
  }, [_vm._v("19")]), _vm._v(". Fritz Hommel, ed., "), _c('i', [_vm._v("Die aethiopische Übersetzung des Physiologus")]), _vm._v(" (Leipzig: J. C. Hinrichs’sche Buchhand-lung, 1877), p. xvi.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p69"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr20",
      "id": "fn20"
    }
  }, [_vm._v("20")]), _vm._v(". Lauchert, p. 65.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p70"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr21",
      "id": "fn21"
    }
  }, [_vm._v("21")]), _vm._v(". "), _c('i', [_vm._v("Das")]), _vm._v(" “Buch der Naturgegenstande” "), _c('i', [_vm._v("herausgegeben und übersetzt von K. Ahrens")]), _vm._v(" (Kiel, 1892), p. 17.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p71"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr22",
      "id": "fn22"
    }
  }, [_vm._v("22")]), _vm._v(". See my notes to chapter I on the lion.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p72"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr23",
      "id": "fn23"
    }
  }, [_vm._v("23")]), _vm._v(". Wellmann, pp. 10–11, esp. note 50.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p73"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr24",
      "id": "fn24"
    }
  }, [_vm._v("24")]), _vm._v(". Migne, PL 14. 261–262.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p74"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr25",
      "id": "fn25"
    }
  }, [_vm._v("25")]), _vm._v(". Lauchert, pp. 80–86.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p75"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr26",
      "id": "fn26"
    }
  }, [_vm._v("26")]), _vm._v(". Sbordone, p. lxxviii.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p76"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr27",
      "id": "fn27"
    }
  }, [_vm._v("27")]), _vm._v(". Lauchert, p. 89.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p77"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr28",
      "id": "fn28"
    }
  }, [_vm._v("28")]), _vm._v(". Ben E. Perry, “Physiologus,” in "), _c('i', [_vm._v("Pauly-Wissowa, Real-Encyclopädie der classischen Altertumswissenschaft")]), _vm._v(", vol. 20, pt. 1 (1941), p. 1120.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p78"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr29",
      "id": "fn29"
    }
  }, [_vm._v("29")]), _vm._v(". Lauchert, pp. 88–89.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p79"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr30",
      "id": "fn30"
    }
  }, [_vm._v("30")]), _vm._v(". See F. L. Cross and E. A. Livingstone, eds., "), _c('i', [_vm._v("The Oxford Dictionary of the Christian Church")]), _vm._v(", 2d ed. (London: Oxford University Press, 1974), p. 385.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p80"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr31",
      "id": "fn31"
    }
  }, [_vm._v("31")]), _vm._v(". See esp. chaps. 4, 17, 20, 22, 34, and 36.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p81"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr32",
      "id": "fn32"
    }
  }, [_vm._v("32")]), _vm._v(". Wellmann, pp. 81–94.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p82"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr33",
      "id": "fn33"
    }
  }, [_vm._v("33")]), _vm._v(". Karl Ahrens, "), _c('i', [_vm._v("Zur Geschichte des sogenannten Physiologus")]), _vm._v(" (Ploen, 1885), pp. 2–3.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p83"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr34",
      "id": "fn34"
    }
  }, [_vm._v("34")]), _vm._v(". Herodotus "), _c('i', [_vm._v("Hist.")]), _vm._v(" 4· 109; Aesop "), _c('i', [_vm._v("Fables")]), _vm._v(" (ed. Halm) 189; Cicero "), _c('i', [_vm._v("Oratio pro")]), _vm._v(" M. "), _c('i', [_vm._v("Aemilio Scauro")]), _vm._v(", frag. 4. 6–7; Apuleius "), _c('i', [_vm._v("Metam.")]), _vm._v(" 1. 9.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p84"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr35",
      "id": "fn35"
    }
  }, [_vm._v("35")]), _vm._v(". Pliny "), _c('i', [_vm._v("Natural History")]), _vm._v(" 8. 41, 59; Aelian "), _c('i', [_vm._v("On Animals")]), _vm._v(" 9.16, 66.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p85"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr36",
      "id": "fn36"
    }
  }, [_vm._v("36")]), _vm._v(". Francesco Sbordone, "), _c('i', [_vm._v("Ricerche sulle fonti e sulla composizione del Physiologus greco")]), _vm._v(" (Naples: Arti Grafiche G. Torella & Figlio, 1936), p. 52; "), _c('i', [_vm._v("Physiologi Graeci")]), _vm._v(", P·37.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p86"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr37",
      "id": "fn37"
    }
  }, [_vm._v("37")]), _vm._v(". Plutarch "), _c('i', [_vm._v("De sollertia animalium")]), _vm._v(" 9760D; Pliny "), _c('i', [_vm._v("Natural History")]), _vm._v(" 8. 62; 21. 39; Aelian "), _c('i', [_vm._v("On Animals")]), _vm._v(" 5. 40. This quality of the panther was a favorite theme among the illustrators of the bestiaries of the later Middle Ages. See Klingender, "), _c('i', [_vm._v("Animals in Art and Thought")]), _vm._v(","), _c('a', {
    attrs: {
      "id": "page_xxxviii"
    }
  }), _vm._v(" plates 216 and 219b; also, "), _c('i', [_vm._v("Physiologus Bernensis, Voll-Faksimile-Ausgabe des Codex Bongarsianus")]), _vm._v(" 318…"), _c('i', [_vm._v("von Christoph Steiger und Otto Hamburger")]), _vm._v(" (Basel: AlkuinVerlag, 1964), plate 17.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p87"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr38",
      "id": "fn38"
    }
  }, [_vm._v("38")]), _vm._v(". See Aristotle "), _c('i', [_vm._v("Históry of the Animals")]), _vm._v(" 9. 6. 612a12; Antigonos (ed. Westermann) 31 (37). 70; Pliny "), _c('i', [_vm._v("Natural History")]), _vm._v(" 8. 62; Aelian "), _c('i', [_vm._v("On Animals")]), _vm._v(" 5. 40, 8. 6 ("), _c('img', {
    attrs: {
      "alt": "",
      "height": "19",
      "src": "images/page_xxxviii_1.jpg",
      "width": "49"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/page_xxxviii_2.jpg",
      "width": "403"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "17",
      "src": "images/page_xxxviii_3.jpg",
      "width": "95"
    }
  }), _vm._v(") It is very likely that the author subjected the legend of the panther to such drastic alteration in order to contrast it with the following chapter on the whale, which attracts fish with its sweet breath. Thus, the motif of the "), _c('img', {
    attrs: {
      "alt": "",
      "height": "15",
      "src": "images/page_xxxviii_4.jpg",
      "width": "55"
    }
  }), _vm._v(" links a figure of damnation (the whale) with a corresponding figure of salvation (the panther).")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p88"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr39",
      "id": "fn39"
    }
  }, [_vm._v("39")]), _vm._v(". Lauchert, pp. 79–80. The study of the later history of "), _c('i', [_vm._v("Physiologus")]), _vm._v(" has been advanced by the research of Lauchert, Henkel, McCulloch, and Perry (see Bibliography).")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p89"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr40",
      "id": "fn40"
    }
  }, [_vm._v("40")]), _vm._v(". The "), _c('i', [_vm._v("Liber Glossarum")]), _vm._v(", called the "), _c('i', [_vm._v("Glossarium Ansileubi")]), _vm._v(" by its early editors Pitra and Mai, was a collection of excerpts from the church fathers, Isidore, Hilarius, Eucherius, Fulgentius, Jumilius, Eutropius, and Orosius, as well as from Cicero’s "), _c('i', [_vm._v("Synonyma, Physiologus")]), _vm._v(", glosses on Vergil and Placidus, and Julian of Toledo; it was probably composed ca. 750 in Spain. See Max Manitius, "), _c('i', [_vm._v("Geschichte der lateinischen Literatur des Mittelalters")]), _vm._v(", vol. 1 (Munich: C. H. Beck, 1965), pp. 133–134.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p90"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr41",
      "id": "fn41"
    }
  }, [_vm._v("41")]), _vm._v(". This important work has recently been edited and translated into English by P. T. Eden. See note 2.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p91"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr42",
      "id": "fn42"
    }
  }, [_vm._v("42")]), _vm._v(". See A. S. Cook, "), _c('i', [_vm._v("The Old English Elene, Phoenix and Physiologus")]), _vm._v(" (New Haven: Yale University Press, 1919), pp. 75–81.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p92"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr43",
      "id": "fn43"
    }
  }, [_vm._v("43")]), _vm._v(". McCulloch, p. 54.")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p93"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr44",
      "id": "fn44"
    }
  }, [_vm._v("44")]), _vm._v(". See note 3")]), _vm._v(" "), _c('p', {
    staticClass: "noteitem",
    attrs: {
      "id": "intro_p94"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#fnr45",
      "id": "fn45"
    }
  }, [_vm._v("45")]), _vm._v(". Sbordone, "), _c('i', [_vm._v("Ricerche")]), _vm._v(", p. 181."), _c('a', {
    attrs: {
      "id": "page_xxxix"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "intro_p47a"
    }
  }, [_vm._v("BIBLIOGRAPHY")]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "intro_p95"
    }
  }, [_vm._v("The following bibliography is appended for those wishing further information about "), _c('i', [_vm._v("Physiologus.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p96"
    }
  }, [_vm._v("Sbordone’s edition (1936) is the starting point for any study of the Greek "), _c('i', [_vm._v("Physiologus;")]), _vm._v(" its massive textual apparatus and thorough listing of classical sources and Christian analogues allow it to supplant the other Greek texts from the first edition of Ponce de Leon (1587) down through those of Pitra (1855) and Lauchert (1889), although Kaimakis’s recent edition (1974) shows that the last word has yet to be uttered. Carmody’s b- and y-versions of the Latin "), _c('i', [_vm._v("Physiologus")]), _vm._v(" provide us with two important families of the Latin text. Both the "), _c('i', [_vm._v("Dicta Chrysostomi")]), _vm._v(" (ed. Heider, 1850) and the Theobaldus version (ed. Eden, 1972), though not taking us back to the original meaning, should be consulted where the reader’s interest is focused on the later history of "), _c('i', [_vm._v("Physiologus.")]), _vm._v(" As has been noted already, the vernacular translations, particularly the Ethiopian (ed. Hommel, 1877) and the Syrian (ed. Land, 1874), are critical to any textual study of "), _c('i', [_vm._v("Physiologus")]), _vm._v(" since they antedate the surviving Greek manuscripts by many centuries.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p97"
    }
  }, [_vm._v("Although not all of Lauchert’s opinions about "), _c('i', [_vm._v("Physiologus")]), _vm._v(" are currently accepted, his "), _c('i', [_vm._v("Geschichte des Physiologus")]), _vm._v(" is in all respects a thorough and meticulous general study of the work, giving important information on the development of each legend, the origin, date, and sources, and the later history of the Greek and Latin text and vernacular translations. Lauchert also notes "), _c('i', [_vm._v("Physiologus’s")]), _vm._v(" influence on Christian art and edits a Greek and German version of "), _c('i', [_vm._v("Physiologus.")]), _vm._v(" To complement and update Lauchert’s research, Well-mann’s excellent study (1930) of the pseudoscientific literary background of "), _c('i', [_vm._v("Physiologus")]), _vm._v(" should be consulted, as well as Sbordone’s "), _c('i', [_vm._v("Ricerche")]), _vm._v(" (1936), which corrects many inaccuracies in previous scholarship from the vantage point of a securely established textual tradition."), _c('a', {
    attrs: {
      "id": "page_xl"
    }
  }), _vm._v(" The latest general survey of "), _c('i', [_vm._v("Physiologus’s")]), _vm._v(" history is Henkel’s stimulating book (1976), which summarizes scholarship to date and provides much new research on the later influence of "), _c('i', [_vm._v("Physiologus")]), _vm._v(" on art, sculpture, and literature (particularly German literature) of the Middle Ages.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "intro_p98"
    }
  }, [_vm._v("Students concerned with "), _c('i', [_vm._v("Physiologus’s")]), _vm._v(" place in art history will wish to consult Klingender (1971) for a general view of the subject and McCulloch (1962) for the bestiary tradition. The detailed study by Evans (1896) and Druce’s essays are still worthwhile. Facsimile editions of two important manuscripts are to be found in James (1929) and Steiger/Hamburger (1964). T. H. White’s translation (1954) and Beryl Rowland’s charming book (1973) both provide numerous fine bestiary illustrations.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "intro_p99"
    }
  }, [_vm._v("Editions")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p100"
    }
  }, [_vm._v("Cahier, Ch. "), _c('i', [_vm._v("Nouveaux mélanges.")]), _vm._v(" 4 vols. Paris, 1874–1877.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p101"
    }
  }, [_vm._v("———, and Martin, A. "), _c('i', [_vm._v("Mélanges d’archéologie, d’histoire et de littérature.")]), _vm._v(" 4 vols. Paris, 1847–1856.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p102"
    }
  }, [_vm._v("Carmody, Francis, ed. "), _c('i', [_vm._v("Physiologus Latinus. Éditions préliminaires, versio")]), _vm._v(" B. Paris: Librairie E. Droz, 1939.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p103"
    }
  }, [_vm._v("———, ed. “Physiologus Latinus, versio Y.” "), _c('i', [_vm._v("The University of California Publications in Classical Philology 12")]), _vm._v(" (1941): 95–134.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p104"
    }
  }, [_vm._v("Cook, A. 5., ed. "), _c('i', [_vm._v("The Old English Elene, Phoenix and Physiologus.")]), _vm._v(" New Haven: Yale University Press, 1919.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p105"
    }
  }, [_vm._v("Eden, P. T., ed. and trans. "), _c('i', [_vm._v("Theobaldi “Physiologus.”")]), _vm._v(" Leiden: E. J. Brill, 1972.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p106"
    }
  }, [_vm._v("Heider, G. “Dicta Joh. Crisostomi de naturis bestiarum.” "), _c('i', [_vm._v("Archiv für Kunde Österreicher Geschichts-Quellen")]), _vm._v(" 5 (1850): 523–582.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p107"
    }
  }, [_vm._v("Hermannson, Halldor. "), _c('i', [_vm._v("The Icelandic Physiologus. Facsimile Edition.")]), _vm._v(" Ithaca, New York: Cornell University Press, 1938.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p108"
    }
  }, [_vm._v("Hommel, Fritz, ed. "), _c('i', [_vm._v("Die aethiopische Übersetzung des Physiologus.")]), _vm._v(" Leipzig: J. C. Hinrichs’sche Buchhandlung, 1877.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xli"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p109"
    }
  }, [_vm._v("Kaimakis, Dimitris, ed. "), _c('i', [_vm._v("Der Physiologus nach der ersten Redaktion.")]), _vm._v(" Meisenheim am Glan: A. Hain, 1974.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p110"
    }
  }, [_vm._v("Land, J. P. N. "), _c('i', [_vm._v("Anecdota Syriaca")]), _vm._v(", Leiden, 1874. (Contains the Syrian translation of "), _c('i', [_vm._v("Physiologus.)")])]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p111"
    }
  }, [_vm._v("Lauchert, Friedrich. "), _c('i', [_vm._v("Geschichte des Physiologus.")]), _vm._v(" Strassburg: Verlag Karl J. Trübner, 1889. (A Greek text is found on pp. 229–279).")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p112"
    }
  }, [_vm._v("Mann, Max Friedrich. “Der Bestiaire Divin des Guillaume Ie Clerc.” "), _c('i', [_vm._v("Französische Studien")]), _vm._v(" 6"), _c('sup', [_vm._v("2")]), _vm._v(" (1888): 37–73.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p113"
    }
  }, [_vm._v("Mauer, Friedrich, ed. "), _c('i', [_vm._v("Der altdeutsche Physiologus, die Millstäter Reimfassung und die Wiener Prosa.")]), _vm._v(" Tübingen: Max Niemeyer Verlag, 1967.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p114"
    }
  }, [_vm._v("Mayer, Alfons. “Der waldensiche "), _c('i', [_vm._v("Physiologus.” Romanische Forschungen")]), _vm._v(" 5 (189 0): 392–418.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p115"
    }
  }, [_vm._v("Pitra, J. B. "), _c('i', [_vm._v("Spicilegium Solesmense.")]), _vm._v(" Paris, 1855.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p116"
    }
  }, [_vm._v("Ponce de Leon, G., ed. "), _c('i', [_vm._v("S.P.N. Epiphanius ad Physiologum.")]), _vm._v(" In "), _c('i', [_vm._v("Patrologia Graeca")]), _vm._v(", edited by J. P. Migne, vol. 43, cols. 518–534. (This is a reprint of the edition of 1587, the earliest printed text of the Greek "), _c('i', [_vm._v("Physiologus")]), _vm._v(", containing twenty-five chapters.)")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p117"
    }
  }, [_vm._v("Sbordone, F., ed. "), _c('i', [_vm._v("Physiologus (Physiologi graeci singulas variarum aetatum recensiones")]), _vm._v("…"), _c('i', [_vm._v("in lucem protulit")]), _vm._v(" F. "), _c('i', [_vm._v("Sbordone).")]), _vm._v(" Milan: In Aedibus Societatis “Dante Alighieri-Albrighi, Segati et C.,” 1936.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p118"
    }
  }, [_vm._v("Steiger, Christoph, and Hamburger, Otto, eds. "), _c('i', [_vm._v("Physiologus Bernensis, Voll-Faksimile-Ausgabe des Codex Bongarsianus")]), _vm._v(" 318. Basel: Alkuin-Verlag, 1964.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "intro_p119"
    }
  }, [_c('i', [_vm._v("Modern Translations")])]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p120"
    }
  }, [_vm._v("Carlill, James. "), _c('i', [_vm._v("Physiologus.")]), _vm._v(" In "), _c('i', [_vm._v("The Epic of the Beast")]), _vm._v(", edited by William Rose. New York: E. P. Dutton & Co., 1924.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p121"
    }
  }, [_vm._v("Carmody, Francis. "), _c('i', [_vm._v("Physiologus, The Very Ancient Book of Beasts, Plants and Stones.")]), _vm._v(" San Francisco: The Book Club of California, 1953.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p122"
    }
  }, [_vm._v("Cook, A. S. "), _c('i', [_vm._v("The Old English Physiologus.")]), _vm._v(" Yale Studies in English, vol. 63. New Haven: Yale University Press, 1921.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p123"
    }
  }, [_vm._v("Eden, P. T. (see above).")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p124"
    }
  }, [_vm._v("Elliott, Thomas J. "), _c('i', [_vm._v("A Medieval Bestiary.")]), _vm._v(" Boston: Godine, 1971.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xlii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p125"
    }
  }, [_vm._v("Rendell, Alan Wood. "), _c('i', [_vm._v("Physiologus. A Metrical Bestiary of Twelve Chapters by Bishop Theobald, Printed in Cologne")]), _vm._v(", 149 2. London: J. & E. Bumpus, 1928.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p126"
    }
  }, [_vm._v("Seel, Otto. "), _c('i', [_vm._v("Der Physiologus, Übertragen und Erläutert von Otto Seel.")]), _vm._v(" Zurich: Artemis Verlag, 1960.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p127"
    }
  }, [_vm._v("White, T. H. "), _c('i', [_vm._v("The Bestiary, A Book of Beasts.")]), _vm._v(" New York: G. P. Putnam’s Sons, 1954.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "intro_p128"
    }
  }, [_c('i', [_vm._v("General Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p129"
    }
  }, [_vm._v("Broek, R. van den. "), _c('i', [_vm._v("The Myth of the Phoenix according to Classical and Early Christian Traditions.")]), _vm._v(" Leiden: E. J. Brill, 1972.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p130"
    }
  }, [_vm._v("Carmody, Francis. "), _c('i', [_vm._v("“De Bestiis et Aliis Rebus")]), _vm._v(" and the Latin "), _c('i', [_vm._v("Physiologus.” Speculum")]), _vm._v(" 13 (April 1938):153–159.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p131"
    }
  }, [_vm._v("Cronin, Grover, Jr. “The Bestiary and the Medieval Mind—Some Complexities.” "), _c('i', [_vm._v("Modern Language Quarterly")]), _vm._v(" 2 (1941):191–198.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p132"
    }
  }, [_vm._v("Druce, G. C. “An Account of the μυρμηkoλωυ or Ant-lion.” "), _c('i', [_vm._v("The Antiquaries Journal")]), _vm._v(" 3 (1923):47–64.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p133"
    }
  }, [_vm._v("———. “The Elephant in Medieval Legend and Art.” "), _c('i', [_vm._v("Archeological Journal")]), _vm._v(" 76 (1919):1–73.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p134"
    }
  }, [_vm._v("———. “The Medieval Bestiaries and Their Influence on Ecclesiastical Decorative Art.” "), _c('i', [_vm._v("The Journal of the British Archeological Association")]), _vm._v(", n.s. 25 (1919): 41–82.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p135"
    }
  }, [_vm._v("Evans, E. P. "), _c('i', [_vm._v("Animal Symbolism in Ecclesiastical Architecture.")]), _vm._v(" London: W. Heinemann, 1896.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p136"
    }
  }, [_vm._v("Gervaise. “Le Bestiaire de Gervaise.” Edited by Paul Meyer. "), _c('i', [_vm._v("Romania")]), _vm._v(" 1 (1872): 420–443.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p137"
    }
  }, [_vm._v("Goldstaub, Max. “Der Physiologus und seine Weiterbildung besonders in der lateinischen und in der Byzantinischen Literatur.” "), _c('i', [_vm._v("Philologus")]), _vm._v(", Supplement-band 8, Heft 3 (1899–1901): 339–404.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p138"
    }
  }, [_vm._v("Guillaume Ie Clerc. "), _c('i', [_vm._v("Das Thierbuch des Normanischen Dichters Guillaume Ie Clerc.")]), _vm._v(" Edited by Robert Reinsch. Leipzig, 1892.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p139"
    }
  }, [_vm._v("Henkel, Nikolaus. "), _c('i', [_vm._v("Studien zum Physiologus im Mittelalter.")]), _vm._v(" Tiibingen: Max Niemeyer Verlag, 1976.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p140"
    }
  }, [_vm._v("James, M. R., ed. "), _c('i', [_vm._v("The Bestiary, Being a Reproduction in Full of the Manuscript 1i.4.26 in the University Library")]), _vm._v(","), _c('a', {
    attrs: {
      "id": "page_xliii"
    }
  }), _vm._v(" "), _c('i', [_vm._v("Cambridge.")]), _vm._v(" Oxford: J. Johnson, at the University Press, 1928.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p141"
    }
  }, [_vm._v("Klingender, Francis. "), _c('i', [_vm._v("Animals in Art and Thought to the End of the Middle Ages.")]), _vm._v(" Edited by Evelyn Antal and John Harthan. Cambridge, Massachusetts; MIT Press, 1971.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p142"
    }
  }, [_vm._v("Lauchert, Friedrich. "), _c('i', [_vm._v("Geschichte des Physiologus.")]), _vm._v(" Strassburg: Verlag Karl J. Trübner, 1889.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p143"
    }
  }, [_vm._v("McCulloch, Florence. "), _c('i', [_vm._v("Medieval Latin and French Bestiaries.")]), _vm._v(" University of North Carolina Studies in Romance Languages and Literatures, no. 33. Chapel Hill, N.C.: University of North Carolina Press, 1962.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p144"
    }
  }, [_vm._v("Perry, Ben E. “Physiologus.” "), _c('i', [_vm._v("Pauly-Wissowa, Real-Encyclopädie der classischen Altertumswissenschaft")]), _vm._v(", vol. 20, pt. 1 (Stuttgart: J. B. Metzlersche Verlagsbuchhand-lung, 1941), cols. 1074–1129.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p145"
    }
  }, [_vm._v("Robin, P. Ansell. "), _c('i', [_vm._v("Animal Lore in English Literature.")]), _vm._v(" London: John Murray, 1932.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p146"
    }
  }, [_vm._v("Rowland, Beryl. "), _c('i', [_vm._v("Animals with Human Faces.")]), _vm._v(" Knoxville, Tenn.: University of Tennessee Press, 1973.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p147"
    }
  }, [_vm._v("Sbordone, Francesco, "), _c('i', [_vm._v("Ricerche sulle fonti e sulla composizione del Physiologus greco.")]), _vm._v(" Naples: Arti Grafiche G. Torella & Figlio, 1936.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p148"
    }
  }, [_vm._v("Philippe de Thaon. "), _c('i', [_vm._v("Le Bestiaire de Philippe de Thaun.")]), _vm._v(" Edited by Emmanuel Walberg. Lund: H. Moller, 1900.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p149"
    }
  }, [_vm._v("Treu, Ursula. “Bestiary.” "), _c('i', [_vm._v("Encyclopedia Britannica")]), _vm._v(", vol. 3. 1970")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p150"
    }
  }, [_vm._v("Wellmann, Max. “Der "), _c('i', [_vm._v("Physiologos")]), _vm._v(", Eine religionsgeschichtlich-naturwissenschaftliche Untersuchung.” "), _c('i', [_vm._v("Philologus")]), _vm._v(", Supplementband 22, Heft 1 (1930):1–116.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p151"
    }
  }, [_vm._v("White, Beatrice. “Medieval Animal Lore.” "), _c('i', [_vm._v("Anglia 72")]), _vm._v(" (1954): 21–30.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyitem",
    attrs: {
      "id": "intro_p152"
    }
  }, [_vm._v("White, Lynn, Jr. “Natural Science and Naturalistic Art in the Middle Ages.” "), _c('i', [_vm._v("American Historical Review 52")]), _vm._v(" (1947): 421–435.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xliv"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22823d67","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/intro.vue
// module id = 69
// module chunks = 0